import {MessageInstance} from "antd/lib/message/interface";

export class MessagesService{
    static messageApi:MessageInstance;
    static init(messageApi:MessageInstance){
        this.messageApi=messageApi;
    }
    static succes(message:string = "Operazione riuscita"){
        MessagesService.messageApi.open({
            type: 'success',
            content: message,
        });
    }
}